import type { PackageContentBlockProps } from "./types";
import PanelContainer from "../../lib/panel/panel-container";
import PanelTranslationState from "../../lib/panel/panel-translation-state";
import { BlockPanelProps } from "../../lib/register-block";
import EmailPanelHidePrices from "./email-panel-hide-prices";


export function PackageContentEmailPanelRenderer(blockProps: BlockPanelProps<PackageContentBlockProps>) {
  return (
    <PanelContainer blockProps={blockProps}>
      <EmailPanelHidePrices />
      <PanelTranslationState mode="auto" portal />
    </PanelContainer>
  );
}
